var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7999 8.164L14.8909 7.482L11.7999 0.199997L8.70893 7.493L0.799927 8.164L6.80593 13.367L5.00193 21.1L11.7999 16.997L18.5979 21.1L16.8049 13.367L22.7999 8.164ZM11.7999 14.94L7.66393 17.437L8.76393 12.729L5.11193 9.561L9.92993 9.143L11.7999 4.71L13.6809 9.154L18.4989 9.572L14.8469 12.74L15.9469 17.448L11.7999 14.94Z",
    fill: "#FFBB3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star_empty.6e6ce0dcbb23a24cde111ff503161abb.svg";
export { ForwardRef as ReactComponent };